import React, { useState } from 'react';
import ChapterwiseMediaList from './ChapterwiseMediaList';
import { Image, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { fetchAdminApi } from '../../../../services/api';

const GetChapterImages = () => {
    const [imageLoaded, setImageloaded] = useState(false);
    const [zoomedImagepath, setZoomedImagepath] = useState(null);
	const fetchResponse = async (record) => {
        try {
            setImageloaded(true);
            const response = await fetchAdminApi(`/preview-image/${record.resource_file_id}`, 'get');
    
            if (response.code === 200 && response.data?.length > 0) {
                setZoomedImagepath(response.data[0].resource_name);
            }
        } catch (error) {
            console.error('Failed to fetch preview image:', error);
        } finally {
            setImageloaded(false);
        }
    };
    const getImageColumns = (fetchPreview) => [
        {
            title: 'Chapter',
            dataIndex: 'chapter_id',
            key: 'chapter_id',
            align: 'center'
        },
        {
            title: 'Img #',
            dataIndex: 'resource_file_id',
            key: 'resource_file_id',
            align: 'center',
            render: (id) => `#${id}`
        },
        {
            title: 'Image',
            dataIndex: 'image_path',
            key: 'image_path',
            align: 'center',
            width: "10%",
            render: (path, record) => (
                <Image
                    src={path}
                    alt="img"
                    onClick={() => fetchPreview(record)}
                    preview={{ src: imageLoaded ? <div>Loading....</div> : zoomedImagepath }}
                />
            )
        },
        {
            title: 'Caption',
            dataIndex: 'caption',
            key: 'caption',
            render: (caption, record) => (
                <Tooltip title={caption}>
                    <Link className='linkColor' to={`/editImage/${record.chapter_id}`} state={{ chapterId: record.chapter_id, entireRecord: record }}>
                        {caption}
                    </Link>
                </Tooltip>
            )
        },
        {
            title: 'Image Name',
            dataIndex: 'resource_name',
            key: 'resource_name'
        }
    ];

	return (
		<ChapterwiseMediaList
			apiEndpoint="/get-image"
			fetchPreview={fetchResponse}
			columns={getImageColumns}
			onAddRoute="/add-image"
			pageTitle="Image"
			pageCrumb="image-list"
		/>
	);
};

export default GetChapterImages;
